const SELECTED_WORKSPACE_KEY = 'selectedWorkspaceId';

export function readSelectedWorkspaceId(): string | null {
  try {
    const v = localStorage.getItem(SELECTED_WORKSPACE_KEY);
    return v && v.trim() ? v : null;
  } catch {
    return null;
  }
}

export function hasWorkspaceInQuery(endpoint: string): boolean {
  const q = endpoint.indexOf('?');
  if (q === -1) return false;
  return /[?&]workspace_id=[^&]/.test(endpoint.slice(q));
}

const WORKSPACE_EXEMPT_PREFIXES = [
  '/auth',
  '/login',
  '/otp',
  '/bootstrap',
  '/profile',
  '/profiles',
  '/users',
  '/admin',
  '/workspaces',
  '/organizations',
  '/business-accounts',
  '/subscription-plans',
  '/addons',
  '/pricing',
  '/payments',
  '/subscriptions',
  '/health',
  '/webhooks',
  '/r',
];

export function isWorkspaceScopedEndpoint(endpoint: string): boolean {
  const path = endpoint.split('?')[0];
  if (WORKSPACE_EXEMPT_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`))) {
    return false;
  }
  return true;
}

export function withWorkspaceParam(
  endpoint: string,
  params: Record<string, any> | undefined,
  body?: any,
): Record<string, any> | undefined {
  if (!isWorkspaceScopedEndpoint(endpoint)) return params;
  if (params?.workspace_id) return params;
  if (hasWorkspaceInQuery(endpoint)) return params;
  if (body && typeof body === 'object' && body.workspace_id) return params;
  const ws = readSelectedWorkspaceId();
  if (!ws) return params;
  return { ...(params || {}), workspace_id: ws };
}

export function withWorkspaceQuery(endpoint: string, body?: any): string {
  if (!isWorkspaceScopedEndpoint(endpoint)) return endpoint;
  if (hasWorkspaceInQuery(endpoint)) return endpoint;
  if (body && typeof body === 'object' && body.workspace_id) return endpoint;
  const ws = readSelectedWorkspaceId();
  if (!ws) return endpoint;
  return `${endpoint}${endpoint.includes('?') ? '&' : '?'}workspace_id=${encodeURIComponent(ws)}`;
}
